import Toast from '../Toast/index'
import { mapGetters } from 'vuex'
export default {
  name: 'TransactionList',
  data () {
    return {

    }
  },
  props: ['unsettled'],
  components: { Toast },
  computed: {

    ...mapGetters([
      'alertMessage',
      'unsettledTransactionList',
      'upcomingPayment',
      'creditPaused',
      'activeTransaction',
      'unsettledTransactionIds',
      'userType',
      'availableCreditLimit',
      'outstandingAmount',
      'user'
    ])
  },
  mounted () {

  },
  methods: {
    goToPayments () {
      let txnString = this.unsettledTransactionIds.join(',')
      let txnAmount = 0.00
      let amt = []
      for (var key in this.unsettledTransactionList) {
        txnAmount += this.unsettledTransactionList[key].netPayableAmount
        amt.push(this.unsettledTransactionList[key].netPayableAmount)
      }

      txnAmount = Math.round(txnAmount * 100) / 100
      // console.log(txnAmount)
      localStorage.setItem('txnAmount', txnAmount)
      localStorage.setItem('txnString', txnString)
      this.query = {
        txnIds: txnString.split(','),
        couponIds: [],
        productFlow: 'generic',
        deviceType: 'WEB'
      }
      localStorage.setItem('paymentQuery', JSON.stringify(this.query))

      this.$router.push({ name: 'PaymentType' })
    },
    setActiveTransaction (txn) {
      // localStorage.setItem('activeTransaction', JSON.stringify(txn))
      this.$store.dispatch('activeTransaction', txn)
      this.$router.push({ path: 'transaction/' + txn.id })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TransactionList/component.js